export default __webpack_public_path__ + "static/media/5453@2x.eabde6db.png";